import React, { FC } from 'react';
import cn from 'classnames';
import styles from './LandscapeAboutContactPersonEditTemplate.module.css';
import { Button, Label } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import { LandscapeAboutContactPersonOrganism } from '../../organisms';
import { Container } from 'react-bootstrap';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';

interface LandscapeAboutContactPersonEditTemplateProps {
  handleOnChange: (contactPerson: LandscapeContactPersonResponseDto) => void;
  contactPerson: LandscapeContactPersonResponseDto;
  callbackFn: (contactPerson: LandscapeContactPersonResponseDto) => void;
  handleCancel: () => void;
}

const LandscapeAboutContactPersonEditTemplate: FC<
  LandscapeAboutContactPersonEditTemplateProps
> = ({ handleOnChange, contactPerson, callbackFn, handleCancel }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Update Contact Person" size="lg" />
          <Button
            className={styles.buttonLink}
            onClick={() =>
              navigate(`/landscapes/edit/${id}/about/contact-person`)
            }
            variant="link"
          >
            Go back
          </Button>
        </div>
        <LandscapeAboutContactPersonOrganism
          handleOnChange={handleOnChange}
          callbackFn={callbackFn}
          contactPerson={contactPerson}
          handleCancel={handleCancel}
        />
      </Container>
    </>
  );
};

export default LandscapeAboutContactPersonEditTemplate;
